/// FOURJS_START_COPYRIGHT(D,2014)
/// Property of Four Js*
/// (c) Copyright Four Js 2014, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("IdleActionNode", ["NodeBase", "NodeFactory"], function (context, cls) {
  /**
   * @class IdleActionNode
   * @memberOf classes
   * @extends classes.NodeBase
   */
  class IdleActionNode extends cls.NodeBase /** @lends classes.IdleActionNode.prototype */ {
    constructor(parent, tag, id, attributes, app) {
      super(parent, tag, id, attributes, app);

      this._timer = null;
      this._timeout = 1000;

      this._isTimer = this.attribute("isTimer");

      this._suffix = "idleAction_" + id;

      const timeoutAttr = this.attribute("timeout");
      if (timeoutAttr > 0) {
        const timeout = timeoutAttr * 1000 || this._timeout;
        this.setTimeout(timeout);

        if (this._isTimer) {
          this.start();
        } else {
          this.activate();
        }
      }
    }

    /**
     * Stop the timer and start it again
     */
    reset() {
      this.stop();
      this._timer = window.setTimeout(this.onTimer.bind(this), this._timeout);
    }

    /**
     * Stop the timer
     */
    stop() {
      if (this._timer) {
        window.clearTimeout(this._timer);
        this._timer = null;
      }
    }

    /**
     * Start the timer
     * note: alias for reset()
     */
    start() {
      this.reset();
    }

    /**
     * Check if timer is running
     * @returns {boolean} true if running, false otherwise
     */
    isRunning() {
      return Boolean(this._timer);
    }

    /**
     * Define the timeout value for this timer
     * @param {number} timeout time in ms
     */
    setTimeout(timeout) {
      this._timeout = timeout;
      if (this.isRunning()) {
        this.reset();
      }
    }

    /**
     * Action trigged when timer is over: send the event to the VM
     */
    onTimer() {
      this._timer = null;
      if (this.getApplication() && !this.getApplication().ending) {
        //Do not send the event if the parent container is not active
        if (this.getParentNode() && this.getParentNode().attribute("active")) {
          this.getApplication().action.executeAction(this, {
            noUserActivity: true,
            sendValue: true
          });
        }
        this.getApplication().dvm.onOrdersManaged(this.start.bind(this), true);
      }
    }

    /**
     * Activate the area where the idle will be caught
     */
    activate() {
      const element = this._application._ui.getWidget().getElement();
      cls.DOMElementHelper.on(element, "mousemove." + this._suffix, this.reset.bind(this));
      cls.DOMElementHelper.on(element, "mousedown." + this._suffix, this.reset.bind(this));
      cls.DOMElementHelper.on(element, "keydown." + this._suffix, this.reset.bind(this));
      this.start();
    }

    /**
     * Deactivate the area where the idle won't be caught
     */
    desactivate() {
      const uiElement = this._application._ui.getWidget().getElement();
      cls.DOMElementHelper.off(uiElement, "mousemove." + this._suffix);
      cls.DOMElementHelper.off(uiElement, "mousedown." + this._suffix);
      cls.DOMElementHelper.off(uiElement, "keydown." + this._suffix);
      this.stop();
    }

    destroy() {
      this.stop();
      super.destroy();
    }
  }
  cls.IdleActionNode = IdleActionNode;
  cls.NodeFactory.register("IdleAction", cls.IdleActionNode);
});
